function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { useMemo, useState } from 'react';
import { Bleed, Button, createForm, DescriptionList, Dialog, Flex, Link, Markdown, NumberInput, Table, Text, useToasts } from '@applyboard/crystal-ui';
import { EditFillIcon } from '@applyboard/ui-icons';
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { useApplication, useApplicationAvailableActions, useSendApplicationAction } from "../../../data";
import { useCommission } from "../../../data/commission";
import { useTranslation } from '@applyboard/ui-utils';
import { match } from 'ts-pattern';
import { Copyable } from "../../../../../components/Copyable";
import { TextareaWithCharacterLimit } from "../../../../../components/TextareaWithCharacterLimit";
import { ApplicationActionName } from "../../../../../types";
import { useCommissionHistory, usePrefetchCommissionHistory } from "../../../data/commissionHistory";
import { IllustratedErrorState } from "../../../../../components/IllustratedErrorState";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function CommissionDetails(_ref) {
  var hiddenSections = _ref.hiddenSections,
    copyEnabled = _ref.copyEnabled;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useCommission = useCommission(),
    commission = _useCommission.commission;
  var _useTranslation = useTranslation('CommissionDetails'),
    t = _useTranslation.t;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [application.paidAt && commission && _jsx(Text, {
      children: t('lockedInMessage', {
        paidAt: new Date(application.paidAt),
        formatParams: {
          paidAt: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          }
        }
      })
    }), !commission && _jsx(Text, {
      children: t('commissionUnavailable')
    }), _jsxs(SideBarDescriptionList, {
      children: [_jsx(DescriptionList.Term, {
        children: t('lockedInTier')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          align: "center",
          gap: 2,
          children: [match(commission === null || commission === void 0 ? void 0 : commission.tier)["with"]('Platinum', function () {
            return _jsx(TierIcon, {
              color: "#003DA1"
            });
          })["with"]('Gold', function () {
            return _jsx(TierIcon, {
              color: "#F8B256"
            });
          })["with"]('Silver', function () {
            return _jsx(TierIcon, {
              color: "#A9B1CC"
            });
          })["with"]('Bronze', function () {
            return _jsx(TierIcon, {
              color: "#D96432"
            });
          })["with"]('Start Up', function () {
            return _jsx(TierIcon, {
              color: "#9BC1FE"
            });
          }).otherwise(function () {
            return null;
          }), _jsx(Copyable, {
            disabled: !copyEnabled,
            children: commission ? commission.tier : '--'
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: t('effectiveRate')
      }), _jsx(DescriptionList.Details, {
        children: _jsxs(Flex, {
          align: "start",
          gap: 4,
          children: [_jsx(Copyable, {
            disabled: !copyEnabled,
            children: commission ? "".concat(formatCommissionRate(commission.commissionRate)).concat(!(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('commissionDetails.rateDisclaimer')) ? '*' : '') : '--'
          }), canPerformApplicationAction(ApplicationActionName.EDIT_COMMISSION) && _jsx(Bleed, {
            mt: 2,
            children: _jsx(EditRateButton, {})
          })]
        })
      }), _jsx(DescriptionList.Term, {
        children: "Effective rate history"
      }), _jsx(DescriptionList.Details, {
        children: commission ? _jsx(ViewHistoryButton, {}) : '--'
      })]
    }), commission && !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('commissionDetails.rateDisclaimer')) && _jsx(Markdown, {
      markdown: t('rateDisclaimer'),
      headingSettings: {
        maxLevel: 0,
        baseLevel: 1
      },
      textSettings: {
        variant: 'bodyS',
        contrast: 'mid'
      }
    })]
  });
}
function ViewHistoryButton() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useTranslation2 = useTranslation('CommissionDetails'),
    t = _useTranslation2.t;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    size: "lg",
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Link, {
        as: "button",
        onClick: function onClick() {},
        children: t('viewHistory.button')
      })
    }), _jsx(Dialog.Heading, {
      children: t('viewHistory.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(CommissionHistoryTable, {})
    }), _jsx(Dialog.Actions, {
      children: _jsx(Flex, {
        justify: "end",
        basis: "100%",
        children: _jsx(Dialog.CloseButton, {
          intent: "primary",
          emphasis: "outlined",
          children: t('viewHistory.close')
        })
      })
    })]
  });
}
function CommissionHistoryTable() {
  var _commissionHistory$;
  var _useCommissionHistory = useCommissionHistory(),
    commissionHistory = _useCommissionHistory.commissionHistory,
    commissionHistoryStatus = _useCommissionHistory.commissionHistoryStatus,
    commissionHistoryError = _useCommissionHistory.commissionHistoryError;
  var firstItemId = (_commissionHistory$ = commissionHistory[0]) === null || _commissionHistory$ === void 0 ? void 0 : _commissionHistory$.id;
  var _useTranslation3 = useTranslation('CommissionDetails'),
    t = _useTranslation3.t;
  var columns = useMemo(function () {
    return [{
      accessorKey: 'commissionRate',
      header: t('historyTable.commissionRate'),
      width: 'content',
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsxs(Text, {
            overflow: "nowrap",
            children: [formatCommissionRate(item.commissionRate), ' ', item.id === firstItemId ? t('historyTable.current') : '']
          })
        });
      }
    }, {
      accessorKey: 'comment',
      header: t('historyTable.comment'),
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsx(Text, {
            children: item.comment || '--'
          })
        });
      }
    }, {
      accessorKey: 'createdAt',
      header: t('historyTable.date'),
      width: 'content',
      cell: function cell(item) {
        return _jsx(Table.Cell, {
          children: _jsx(Text, {
            overflow: "nowrap",
            children: new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            }).format(new Date(item.createdAt))
          })
        });
      }
    }];
  }, [firstItemId, t]);
  if (commissionHistoryError) {
    return _jsx(IllustratedErrorState, {
      error: commissionHistoryError,
      variant: "compact"
    });
  }
  return _jsx(Table, {
    loading: commissionHistoryStatus === 'loading',
    columns: columns,
    data: commissionHistory
  });
}
function TierIcon(_ref2) {
  var color = _ref2.color;
  return _jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    children: _jsx("path", {
      fill: color,
      fillRule: "evenodd",
      d: "M13.31 1.144a2 2 0 0 0-2.627 0L8.34 3.186a2 2 0 0 1-.953.459l-3.058.56A2 2 0 0 0 2.69 6.258l.134 3.106a2 2 0 0 1-.235 1.032l-1.469 2.74a2 2 0 0 0 .585 2.56l2.512 1.832a2 2 0 0 1 .66.827l1.226 2.857a2 2 0 0 0 2.367 1.14l2.998-.823a2 2 0 0 1 1.057 0l2.999.823a2 2 0 0 0 2.366-1.14l1.227-2.857c.142-.33.37-.615.66-.827l2.512-1.831a2 2 0 0 0 .584-2.561l-1.469-2.74a2 2 0 0 1-.235-1.032l.134-3.106a2 2 0 0 0-1.637-2.053l-3.058-.56a2 2 0 0 1-.953-.46L13.31 1.145Zm3.394 7.15a1 1 0 0 1 0 1.414l-6.208 6.207-3.207-3.207a1 1 0 1 1 1.415-1.415l1.792 1.793 4.793-4.793a1 1 0 0 1 1.415 0Z",
      clipRule: "evenodd"
    })
  });
}
function formatCommissionRate(commissionRate) {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 2
  }).format(commissionRate / 100);
}
var _createForm = createForm(),
  EditRateForm = _createForm.Form,
  EditRateField = _createForm.Field;
function EditRateButton() {
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useTranslation4 = useTranslation('CommissionDetails'),
    t = _useTranslation4.t;
  var _useSendApplicationAc = useSendApplicationAction(),
    sendApplicationAction = _useSendApplicationAc.sendApplicationAction,
    sendApplicationActionStatus = _useSendApplicationAc.sendApplicationActionStatus;
  var prefetchCommissionHistory = usePrefetchCommissionHistory();
  var toasts = useToasts();
  var _useCommission2 = useCommission(),
    commission = _useCommission2.commission;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        "aria-label": t('editRateDialog.title'),
        leadIcon: EditFillIcon,
        intent: "primary",
        emphasis: "transparent",
        size: "sm"
      })
    }), _jsx(Dialog.Heading, {
      children: t('editRateDialog.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(EditRateForm, {
        id: "editRateForm",
        defaultValues: {
          commissionRate: (commission === null || commission === void 0 ? void 0 : commission.commissionRate.toString()) || '',
          comment: ''
        },
        onSubmit: function onSubmit(values) {
          return sendApplicationAction({
            actionId: ApplicationActionName.EDIT_COMMISSION,
            actionData: {
              commissionRate: values.commissionRate,
              comment: values.comment
            }
          }, {
            onSuccess: function onSuccess() {
              prefetchCommissionHistory();
              setIsOpen(false);
              toasts.positive(t('editRateDialog.success'));
            },
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              }
            }
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 4,
          align: "start",
          children: [_jsx(EditRateField, {
            as: NumberInput,
            name: "commissionRate",
            min: 0,
            max: 100,
            label: t('editRateDialog.effectiveRate'),
            required: t('editRateDialog.requiredError'),
            validate: function validate(value) {
              var rate = Number(value);
              if (rate < 1 || rate > 100) {
                return t('editRateDialog.rateValueError');
              }
              return true;
            }
          }), _jsx(Flex.Item, {
            width: "fill",
            children: _jsx(EditRateField, {
              as: TextareaWithCharacterLimit,
              name: "comment",
              label: t('editRateDialog.comment'),
              required: t('editRateDialog.requiredError'),
              helpText: t('editRateDialog.commentHelpText'),
              validate: function validate(value) {
                if (value.length > 500) {
                  // Returning an empty string to use the default error message here
                  return '';
                }
                return true;
              },
              characterLimit: 500
            })
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('editRateDialog.cancel')
      }), _jsx(Button, {
        intent: "primary",
        type: "submit",
        form: "editRateForm",
        loading: sendApplicationActionStatus === 'loading',
        width: "fill",
        children: t('editRateDialog.save')
      })]
    })]
  });
}